/* eslint-disable @next/next/no-img-element */
import React from "react";
import SingleStar from "../../VibehutUI/Icons/SingleStar";
import { Promotion } from "../../types";

export const HomePromotion: React.FC = () => {
  const localApprovedPromotion = localStorage.getItem("ApprovedPromotion");
  const parsedLocalPromotion: Promotion & { recordId: string } =
    localApprovedPromotion
      ? JSON.parse(localApprovedPromotion)
      : { isApproved: false };
  return parsedLocalPromotion?.isApproved ? (
    <div
      className="flex max-h-60  items-end rounded-xl cursor-pointer p-2 py-4  relative bg-no-repeat  bg-cover  bg-blend-multiply shadow-md drop-shadow-md promotion-banner mt-2 sm:mt-0"
      style={{
        backgroundImage: `linear-gradient(
      to left,
      rgba(245, 246, 252, 0.52),
      rgba(0, 0, 0, 0.73)
    ),
    url(${parsedLocalPromotion.image ? parsedLocalPromotion.image : ""})`,
      }}
    >
      <span className="absolute -left-4 -top-4">
        <SingleStar size="22" color="#5B57FF" />
      </span>
      <div className="w-1/2 ml-8 flex flex-col items-start pt-3">
        <p className="sm:text-3xl text-xl font-bold text-frescoWhite">
          {parsedLocalPromotion.title}
        </p>

        <p className="text-gray-300 hidden sm:block">
          {parsedLocalPromotion.description}
        </p>
        <a
          href={parsedLocalPromotion.link}
          target="_blank"
          type="button"
          className="promotion-btn"
        >
          Click Here
        </a>
      </div>
    </div>
  ) : (
    <></>
  );
};
